<cdk-virtual-scroll-viewport class="tableDiv" tvsItemSize="40">
  <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-table-sort-mod">
    <ng-container [matColumnDef]="col" *ngFor="let col of displayedColumns">
      <th [class]="styles.headerCol" [style.font-size.px]="headerFontSize" mat-header-cell *matHeaderCellDef #header mat-sort-header [class.standalone]="true" [style.color]="headerColor">
        <div class="col-name-container">{{ col }}</div>
        <div style="margin-left: 10px ;">
          <i class="fad fa-sort"
            [class.fa-sort-down]="header['_sort'].active == col && header['_sort'].direction=='desc'"
            [class.fa-sort-up]="header['_sort'].active == col && header['_sort'].direction=='asc'"></i>
        </div>
      </th>
      <td [class]="styles.rowCol" [style.font-size.px]="rowFontSize" mat-cell *matCellDef="let element" [style.color]="rowColor">
        <span>{{ element[col] }}</span>
      </td>
    </ng-container>
    <tr [ngClass]="hasGrouping ? ['group-table-header', styles.header] : styles.header" mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      [ngClass]="row.isOdd ? hasGrouping ? ['group-table-row', styles.oddRow] : styles.oddRow : hasGrouping ? ['group-table-row', styles.evenRow] : styles.evenRow"
      mat-row *matRowDef="let row; columns: displayedColumns;" [style.color]="rowColor"></tr>
    <ng-container matColumnDef="groupHeader">
      <td colspan="999" mat-cell *matCellDef="let group">
        <!-- <span><strong>{{group.groupName}}</strong></span> -->
      </td>
    </ng-container>
    <ng-container matColumnDef="groupReducer">
      <td colspan="1" mat-cell *matCellDef="let group">
        <div fxFill fxLayoutAlign="center center">
          <i *ngIf="!group.reduced" class="fas fa-minus"></i>
          <i *ngIf="group.reduced" class="fas fa-plus"></i>
          <span class="group-name"><strong>{{group.groupName}}</strong></span>
        </div>
      </td>
    </ng-container>

    <tr mat-row class="clickable" *matRowDef="let row; columns: ['groupReducer', 'groupHeader']; when: isGroup"
      (click)="reduceGroup(row)">
    </tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</cdk-virtual-scroll-viewport>
